import React from 'react';
import PropTypes from 'prop-types';
import * as S from './SecondaryButton.styles';
import BaseButton from '../BaseButton/BaseButton';

const SecondaryButton = ({ children, className, ...other }) => (
    <S.SecondaryButton>
      <BaseButton className={`secondaryButton${className ? ` ${className}` : ''}`} {...other}>
        {children}
      </BaseButton>
    </S.SecondaryButton>
  );

SecondaryButton.defaultProps = {
  children: '',
  className: '',
  spinnerColor: '#009343'
};

SecondaryButton.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  spinnerColor: PropTypes.string
};

export default SecondaryButton;
